import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
// import reportWebVitals from './ReportWebVitals';
import { Persistor, Store } from './stores';

// Add type assertion to fix Provider JSX issue
const ProviderWrapper = Provider as any;

// eslint-disable-next-line import/no-named-as-default-member
ReactDOM.render(
  <React.StrictMode>
    <ProviderWrapper store={Store}>
      <PersistGate loading={null} persistor={Persistor}>
        <App />
      </PersistGate>
    </ProviderWrapper>
  </React.StrictMode>,
  document.getElementById('root'),
);
